import { type CountryProperty, customList } from "country-codes-list";
import type { TFunction } from "i18next";

import type { CountryCode } from "@/base/components/Global/PhoneField/types";
import config from "@/constants/config";

import { flags } from "./Flag";

const DEFAULT_COUNTRY = `global_phone_field_default_country_${config.appConfig.defaultLanguage}`;

// (AN - Netherlands Antilles) - Disabled because we don't have a flag for it
const EXCLUDED_COUNTRY_CODES = new Set(["AN"]);

const sortCountryCodes = (codes: string[], t: TFunction): string[] => {
  const defaultCountry = t(DEFAULT_COUNTRY, {
    defaultValue: DEFAULT_COUNTRY,
  });
  const hasDefaultCountry = defaultCountry !== DEFAULT_COUNTRY;

  const marketCountries: string[] = t(
    `global_phone_field_market_countries_${config.appConfig.defaultLanguage}`,
    { defaultValue: "" },
  ).split(" ");
  const newCodes = hasDefaultCountry ? [defaultCountry] : [];

  for (const marketCountryCode of marketCountries) {
    if (
      !newCodes.includes(marketCountryCode) &&
      codes.includes(marketCountryCode)
    ) {
      newCodes.push(marketCountryCode);
    }
  }

  for (const code of codes) {
    if (!newCodes.includes(code)) {
      newCodes.push(code);
    }
  }

  return newCodes;
};

const getCountryCodes = (t: TFunction): CountryCode[] => {
  const countryNameEn: Record<string, string> = customList(
    "countryCode" as CountryProperty,
    "{countryNameEn}",
  );
  const countryNameLocal: Record<string, string> = customList(
    "countryCode" as CountryProperty,
    "{countryNameLocal}",
  );
  const countryCallingCode: Record<string, string> = customList(
    "countryCode" as CountryProperty,
    "{countryCallingCode}",
  );
  const sortedCountryCodes: string[] = sortCountryCodes(
    Object.keys(countryNameEn),
    t,
  ).filter((code) => !EXCLUDED_COUNTRY_CODES.has(code));

  return sortedCountryCodes.map((countryCode: string) => {
    const flagUrl = countryCode ? flags[countryCode] : null;

    const title =
      countryNameLocal[countryCode] === countryNameEn[countryCode]
        ? countryNameEn[countryCode]
        : `${countryNameEn[countryCode]} (${countryNameLocal[countryCode]})`;

    const code = `+${countryCallingCode[countryCode].replaceAll(/\D+/g, "")}`;

    return {
      code,
      flagUrl,
      title,
    } as CountryCode;
  });
};

export { getCountryCodes, sortCountryCodes };
